import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-liste-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerListeAdminEffects {

    BenutzerListeAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_LISTE_ADMIN),
        mergeMap((x: ac.GetBenutzerListeAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerListeAdmin().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerListeAdminErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerListeAdminFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminQueryService);
        }
        return this.service;
    }
}
